import { getEyeAbleDomain } from '@/components/EyeAbleScript/getEyeAbleDomain';
import Icon from '@uikit/components/Icon/Icon';
import Link from '@uikit/components/Link/Link';
import clsx from 'clsx';
import styles from './PreHeader.module.scss';
import { PreHeaderProps } from './types';

const PreHeader = ({
  audiences = [],
  isFullWidth = false,
  isInverted = false,
  links = [],
}: PreHeaderProps) => {
  const content = (
    <nav
      className={clsx(styles.base, {
        [styles.isInverted]: isInverted,
      })}
      aria-label="Sekundäre Navigationsleiste"
    >
      {audiences.map(({ isActive, title, url }) => (
        <a
          className={clsx(styles.link, {
            [styles.isActive]: isActive,
          })}
          href={url}
          key={url}
        >
          {title}
        </a>
      ))}

      <div className={styles.divider} role="separator" />

      {!!getEyeAbleDomain() && (
        <button
          className={styles.item}
          onClick={() => window.EyeAbleAPI?.toggleToolbar()}
        >
          {/* This blocks the native EyeAble trigger */}
          <span
            className="eyeAble_customToolOpenerClass"
            style={{
              display: 'none',
            }}
          />
          <Icon
            className={styles.icon}
            isOutlined
            size="iconSize20"
            variant="user/accessability"
          />
          <span className={styles.text}>Visuelle Hilfe</span>
        </button>
      )}

      {links.map((link) => {
        return link.isInternalUrl ? (
          <Link className={styles.item} to={link.url} key={link.title}>
            {link.icon && (
              <Icon
                className={styles.icon}
                isOutlined
                size="iconSize20"
                variant={link.icon}
              />
            )}
            <span className={styles.text}>{link.title}</span>
          </Link>
        ) : (
          <a className={styles.item} href={link.url} key={link.title}>
            {link.icon && (
              <Icon
                className={styles.icon}
                isOutlined
                size="iconSize20"
                variant={link.icon}
              />
            )}
            <span className={styles.text}>{link.title}</span>
          </a>
        );
      })}
    </nav>
  );

  return isFullWidth ? (
    <div
      className={clsx(styles.fullWidthContainer, {
        [styles.isInverted]: isInverted,
      })}
    >
      {content}
    </div>
  ) : (
    content
  );
};

export default PreHeader;
